/**
 * Failover control-plane constants (source of truth = Firestore `system/failover`).
 *
 * The `system/failover` doc is the SINGLE source of truth for which Firebase
 * project clients should use. Only admins/super-admins may write it
 * (see firestore.rules `match /system/{documentId}`); any authenticated client
 * may read it. Clients NEVER decide failover autonomously — they obey this doc.
 *
 * MIRRORED (must stay byte-identical) in:
 *   - backend/src/config/failoverControl.ts
 */

export const FAILOVER_CONTROL_COLLECTION = 'system' as const;

export const FAILOVER_CONTROL_DOC_ID = 'failover' as const;

/** Doc field naming the active project. */
export const FAILOVER_ACTIVE_PROJECT_FIELD = 'activeProject' as const;

export const FAILOVER_PROJECT_PRIMARY = 'primary' as const;

export const FAILOVER_PROJECT_SECONDARY = 'secondary' as const;

export type FailoverActiveProject =
  | typeof FAILOVER_PROJECT_PRIMARY
  | typeof FAILOVER_PROJECT_SECONDARY;
